import Head from "next/head";
import { fromUrl, toUrl } from "common/src/Aperture.bs";
import * as T from "common/src/bindings/Translation2.ts";
import { make as UnitsPage } from "../../src/stats/UnitsPage.bs";
import { make as UnitPage } from "../../src/stats/UnitPage.bs";
import { renderFull, toApiUrl as patchToUrl } from "common/src/Patch.bs";
import { fromUrlName } from "common/src/tft-static/Sd.ts";
import { statsSet } from "common/src/Config.ts";

export default function Home({
  aperture,
  statsData,
  unitId,
  starLevel,
  unitData,
}) {
  if (unitId != null) {
    return (
      <>
        <Head>
          <title>{`${T.units(
            unitId,
          )} TFT Stats - Best Items, Synergies, Counrers Set 14 Patch ${renderFull(
            aperture.patch,
          )}`}</title>
        </Head>
        <UnitPage unitId={unitId} unitData={unitData} starLevel={starLevel} />
      </>
    );
  } else {
    return (
      <>
        <Head>
          <title>
            {`TFT Units Stats - Best Units for Set 14 Patch ${renderFull(
              aperture.patch,
            )}`}
          </title>
        </Head>
        <UnitsPage statsData={statsData} />
      </>
    );
  }
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ params, locale }) {
  const unitId =
    params.slug?.[0] === "kayle"
      ? "TFT11_Kayle"
      : fromUrlName(params.slug?.[0], statsSet);
  if (unitId != null) {
    let sl = parseInt(params.slug[1]);
    let aperture;
    if (!isNaN(sl) && sl >= 1 && sl <= 4) {
      aperture = fromUrl(params.slug.slice(1));
    } else {
      sl = 0;
      aperture = fromUrl(params.slug.slice(1));
    }

    const path =
      sl === 0
        ? `/unit/${aperture.queue}/${unitId}`
        : `/sunit/${aperture.queue}/${unitId}/${sl}`;

    const unitResp = await fetch(
      `https://d3.tft.tools/stats2${path}/${patchToUrl(aperture.patch)}/${
        aperture.rankGroup
      }`,
    );
    const unitData = await unitResp.json();

    return {
      props: {
        unitId,
        starLevel: sl,
        aperture,
        unitData,
        initialKey: toUrl(aperture),
      },
      revalidate: 3600,
    };
  } else {
    const aperture = fromUrl(params.slug || []);

    const statsResp = await fetch(
      `https://d3.tft.tools/stats2/general/${aperture.queue}/${patchToUrl(
        aperture.patch,
      )}/${aperture.rankGroup}`,
    );
    const statsData = await statsResp.json();

    return {
      props: {
        aperture,
        statsData,
        initialKey: toUrl(aperture),
      },
      revalidate: 3600,
    };
  }
}
